var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewStarActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 188",
    fill: "rgba(139,68,68,0)",
    d: "M0 0h22v22H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "star this message"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1568",
    d: "M20.444 10.069a1.565 1.565 0 00.371-1.566 1.474 1.474 0 00-1.182-1.04l-4.861-.737a.294.294 0 01-.221-.167L12.38 1.965a1.438 1.438 0 00-2.626 0L7.581 6.559a.294.294 0 01-.221.167l-4.859.737a1.474 1.474 0 00-1.182 1.04 1.565 1.565 0 00.371 1.566l3.516 3.576a.314.314 0 01.084.271l-.83 5.049a1.55 1.55 0 00.583 1.495 1.405 1.405 0 001.542.116l4.346-2.384a.282.282 0 01.273 0l4.346 2.384a1.4 1.4 0 001.542-.116 1.55 1.55 0 00.58-1.495l-.83-5.049a.314.314 0 01.084-.271zm-4.755 4.054l.83 5.05a.3.3 0 01-.116.3.276.276 0 01-.308.023l-4.346-2.384a1.411 1.411 0 00-1.363 0L6.04 19.496a.276.276 0 01-.308-.023.3.3 0 01-.116-.3l.83-5.049a1.569 1.569 0 00-.421-1.353L2.509 9.195a.307.307 0 01-.074-.313.29.29 0 01.237-.209l4.859-.737a1.47 1.47 0 001.1-.836l2.173-4.597a.288.288 0 01.525 0h0l2.173 4.6a1.47 1.47 0 001.1.836l4.859.737a.29.29 0 01.236.208.307.307 0 01-.074.313l-3.516 3.576a1.569 1.569 0 00-.418 1.35z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "star"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 188",
    fill: "rgba(139,68,68,0)",
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "star this message"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1568",
    d: "M20.444 10.069a1.565 1.565 0 00.371-1.566 1.474 1.474 0 00-1.182-1.04c-4.954-.751-5.037-.814-7.252-5.5a1.438 1.438 0 00-2.626 0L7.581 6.559a.294.294 0 01-.221.167l-4.859.737a1.474 1.474 0 00-1.182 1.04 1.565 1.565 0 00.371 1.566l3.516 3.576a.314.314 0 01.084.271l-.83 5.049a1.55 1.55 0 00.583 1.495 1.405 1.405 0 001.542.116l4.346-2.384a.282.282 0 01.273 0l4.346 2.384a1.4 1.4 0 001.542-.116 1.55 1.55 0 00.58-1.495l-.83-5.049a.314.314 0 01.084-.271z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewStarActive);
export default __webpack_public_path__ + "static/media/preview_star_active.8e64a569af4e0341b5369fde7465fd0c.svg";
export { ForwardRef as ReactComponent };